import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import { getDataEndPoint, updateDataEndPoint } from "app/utils/constants/paths";
import { addslashes } from "app/utils/utils";
import axiosApiInstance from "app/services/axios";
import uuid from "react-uuid";
import { DATASOURCE_CONFIG } from "app/config";
const tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const initialState = {
  loading: false,
  supplyDealsList: [],
  supplyDealDetails: {
    dealId: "",
    name: "",
    floor: "",
    duration: "",
    company: "",
    account: "",
    publisher: "",
    whitelistAccounts: "",
    auctiontype: "",
    contentTypes: "",
  },
};

export const GetAllSupplyDealsListThunk = createAsyncThunk(
  "supplydeal/GetAllSupplyDealsListThunk",
  async (payload) => {
    var isSysAdmin = payload?.authUserData?.is_sys_admin;
    var userProfile = payload?.authUserData?.user_assoc_profiles;
    let condition = [];

    if (
      payload?.search != "" &&
      payload?.search != undefined &&
      payload?.search != null
    ) {
      condition.push(
        "rds.name " +
          DATASOURCE_CONFIG.QUERY_LIKE +
          " '%" +
          payload.search +
          "%'"
      );
    }
    if (isSysAdmin != 1) {
      if (
        userProfile.includes("publisher") &&
        payload.authUserData?.user_assoc_accounts?.publisher.length > 0
      ) {
        condition.push(
          "rds.accountid IN ('" +
            payload.authUserData?.user_assoc_accounts?.publisher.join("','") +
            "')"
        );

        if (
          userProfile.includes("publisher") &&
          payload.authUserData?.user_assoc_publishers.length > 0
        ) {
          condition.push(
            "rds.publisher IN ('" +
              payload.authUserData?.user_assoc_publishers.join("','") +
              "')"
          );
        }
      } else {
        condition.push("rds.accountid  IN ('0')");
      }
    }

    let where = "";
    condition.push(
      "rds.status='0' and rds.accountid =a.id and rds.publisher=p.pub_code"
    );
    if (condition.length > 0) {
      where = "where " + condition.join(" and ") + "";
    }

    const queryBody = {
      queries: [
        {
          query:
            "select rds.id,rds.dealid,rds.name,rds.floor,rds.publisher,rds.accountid,rds.company,(select name from " +
            tablePrefix +
            "companies where id=rds.company) as company_name,a.company as account_name,p.name as publisher_name,rds.activate_time,rds.expire_time,rds.creation_date  from " +
            tablePrefix +
            "rtb_deals_supply as rds, " +
            tablePrefix +
            "accounts as a, " +
            tablePrefix +
            "publishers as p " +
            where +
            " order by rds.creation_date desc",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const InsertUpdateSupplyDealDetailsThunk = createAsyncThunk(
  "supplydeal/InsertUpdateSupplyDealDetailsThunk",
  async (payload) => {
    //console.log('payload', payload)
    let insertUpdateQuery = "";
    let insertUpdateArr = [];
    let InsertDeleteDealAccountAssocQuery = [];
    let dealid = "";
    if (payload.id == "" || payload.id == null || payload.id == undefined) {
      if (
        payload.dealId == "" ||
        payload.dealId == null ||
        payload.dealId == undefined
      ) {
        dealid = uuid();
      } else {
        dealid = payload.dealId;
      }
      insertUpdateQuery =
        "insert into " +
        tablePrefix +
        "rtb_deals_supply (id,dealid,name,floor,company,accountid,publisher,auction_type,content_type,activate_time,expire_time,created_by,creation_date) values('" +
        uuid() +
        "','" +
        dealid +
        "','" +
        addslashes(payload.name) +
        "','" +
        payload.floor +
        "','" +
        payload.company +
        "','" +
        payload.account +
        "','" +
        payload.publisher +
        "','" +
        payload.auctionType +
        "','" +
        payload.contentTypes +
        "','" +
        payload.startDate +
        "','" +
        payload.endDate +
        "','" +
        payload.created_by +
        "'," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        ") ";

      insertUpdateArr.push({
        query: insertUpdateQuery,
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      });

      if (payload.whitelistAccounts.length > 0) {
        let insertValues = [];
        payload.whitelistAccounts.map((acc) => {
          console.log("wacc", acc);
          insertValues.push("('" + dealid + "','" + acc + "')");
        });
        InsertDeleteDealAccountAssocQuery.push({
          query:
            "insert into " +
            tablePrefix +
            "rtb_deals_supply_account_assoc (dealid,accountid) values " +
            insertValues.join(",") +
            "",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
    } else {
      dealid = payload.id;
      insertUpdateQuery =
        "update " +
        tablePrefix +
        "rtb_deals_supply set name='" +
        addslashes(payload.name) +
        "',floor='" +
        payload.floor +
        "',company='" +
        payload.company +
        "',accountid='" +
        payload.account +
        "',publisher='" +
        payload.publisher +
        "',auction_type='" +
        payload.auctionType +
        "',content_type='" +
        payload.contentTypes +
        "',activate_time='" +
        payload.startDate +
        "',expire_time='" +
        payload.endDate +
        "' where dealid='" +
        payload.id +
        "'";

      insertUpdateArr.push({
        query: insertUpdateQuery,
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      });
      InsertDeleteDealAccountAssocQuery.push({
        query:
          "delete from " +
          tablePrefix +
          "rtb_deals_supply_account_assoc where dealid='" +
          payload.id +
          "'",
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      });
      if (payload.whitelistAccounts.length > 0) {
        let insertValues = [];
        payload.whitelistAccounts.map((acc) => {
          console.log("wacc", acc);
          insertValues.push("('" + dealid + "','" + acc + "')");
        });
        InsertDeleteDealAccountAssocQuery.push({
          query:
            "insert into " +
            tablePrefix +
            "rtb_deals_supply_account_assoc (dealid,accountid) values " +
            insertValues.join(",") +
            "",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
    }
    let queriesArr = [...insertUpdateArr, ...InsertDeleteDealAccountAssocQuery];

    console.log("queriesArr", queriesArr);
    const queryBody = {
      queries: queriesArr,
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetSupplyDealDetailsThunk = createAsyncThunk(
  "supplydeal/GetSupplyDealDetailsThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select * from " +
            tablePrefix +
            "rtb_deals_supply where dealid='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "select * from " +
            tablePrefix +
            "rtb_deals_supply_account_assoc where dealid='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const UpdateSupplyDealStatusThunk = createAsyncThunk(
  "company/UpdateCompanyStatusThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "update " +
            tablePrefix +
            "companies set status='0' where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

const SupplyDeal = createSlice({
  name: "supplydeal",
  initialState,
  reducers: {
    resetSupplyDealForm(state, action) {
      state.supplyDealDetails = {
        dealId: "",
        name: "",
        floor: "",
        duration: "",
        company: "",
        account: "",
        publisher: "",
        whitelistAccounts: "",
        auctiontype: "",
        contentTypes: "",
      };
    },
  },

  extraReducers(builder) {
    builder
      .addCase(GetAllSupplyDealsListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllSupplyDealsListThunk.fulfilled, (state, action) => {
        if (action.payload.data.results[0]) {
          state.supplyDealsList = action.payload.data.results[0];
        }

        state.loading = false;
      })
      .addCase(GetAllSupplyDealsListThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(InsertUpdateSupplyDealDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        InsertUpdateSupplyDealDetailsThunk.fulfilled,
        (state, action) => {
          if (!action.payload.data?.error) {
            let supplyDealData = {
              dealId: action.meta.arg.dealid,
              name: action.meta.arg.name,
              floor: action.meta.arg.floor,
              startDate: action.meta.arg.startDate,
              endDate: action.meta.arg.endDate,
              company: action.meta.arg.company,
              account: action.meta.arg.account,
              publisher: action.meta.arg.publisher,
              whitelistAccounts: action.meta.arg.whitelistAccounts,
              auctiontype: action.meta.arg.auctionType,
              contentTypes: action.meta.arg.contentTypes,
            };

            state.supplyDealDetails = supplyDealData;
          }
          state.loading = false;
        }
      )
      .addCase(InsertUpdateSupplyDealDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })

      .addCase(GetSupplyDealDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetSupplyDealDetailsThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results[0].length > 0) {
          let resultData = action.payload.data?.results[0][0];
          let dealAccountAssocRes = action.payload.data?.results[1];
          let whitelistAccounts = [];
          dealAccountAssocRes.map((info) => {
            whitelistAccounts.push(info.accountid);
          });
          let supplyDealData = {
            dealId: resultData.dealid,
            name: resultData.name,
            floor: resultData.floor.toString(),
            startDate: resultData.activate_time,
            endDate: resultData.expire_time,
            company: resultData.company,
            account: resultData.accountid,
            publisher: resultData.publisher,
            whitelistAccounts: whitelistAccounts,
            auctiontype: resultData.auction_type.toString(),
            contentTypes: resultData.content_type,
          };
          state.supplyDealDetails = supplyDealData;
        }
        state.loading = false;
      })
      .addCase(GetSupplyDealDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(UpdateSupplyDealStatusThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateSupplyDealStatusThunk.fulfilled, (state, action) => {
        if (action.payload.data?.error == false) {
          // let companyList = state.companiesList;
          // let companyId = action.meta.arg.id;
          // companyList = companyList.filter((item) => item.id !== companyId);
          // state.companiesList = companyList;
        }
        state.loading = false;
      })
      .addCase(UpdateSupplyDealStatusThunk.rejected, (state, action) => {
        state.loading = false;
      });
  },
});
const { actions, reducer } = SupplyDeal;
// Extract and export each action creator by name
export const { resetSupplyDealForm } = actions;
// Export the reducer, either as a default or named export
export default reducer;
